/* eslint-disable object-curly-newline */
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  incrementPendingRequestCount({ commit }) {
    return storeActionCommit(commit, 'incrementPendingRequestCount')();
  },

  decrementPendingRequestCount({ commit }) {
    return storeActionCommit(commit, 'decrementPendingRequestCount')();
  },

  initStore() {
    const xCart = localStorage.getItem('x-cart');
    if (xCart != null) {
      this.dispatch('shoppingCart/fetchShoppingCart', {
        id: xCart,
      });
    }

    this.dispatch('user/createTempUser');
  },

};
